import React, {useEffect} from "react";

const cssStyles = `
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes bounceIn {
  0% {
    transform: scale(0.3);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  70% {
    transform: scale(0.9);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`;

const Toast = ({message, type, onClose, isVisible}) => {
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = cssStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const baseClasses = `
    fixed top-5 right-5 
    p-4 rounded-lg 
    shadow-lg 
    transform
    animate-[bounceIn_0.5s_ease-in-out]
    hover:scale-105 
    transition-transform
    duration-200
    z-50
  `;

  const typeClasses = type === "success" ? "bg-x-yellow text-x-gray-dark border-2 border-x-gray-dark" : "bg-x-red text-white border-2 border-x-red";

  return (
    <div
      className={`${baseClasses} ${typeClasses}`}
      style={{
        boxShadow: "3px 3px 0px 3px black",
      }}>
      <div className="flex items-center ">
        <div className="animate-[bounceIn_0.6s_ease-in-out]">
          {type === "success" ? (
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
        </div>
        <p className="font-bold animate-[bounceIn_0.7s_ease-in-out]">{message}</p>
        <button onClick={onClose} className="ml-4 hover:opacity-75 transition-opacity duration-200">
          <svg className="w-4 h-4 animate-[bounceIn_0.8s_ease-in-out]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-black bg-opacity-20">
        <div
          className="h-full bg-current opacity-40"
          style={{
            width: "100%",
            animation: "shrink 3s linear forwards",
          }}
        />
      </div>
    </div>
  );
};

export default Toast;
